import apiClient from '@/services/axios'

export async function patch(guestListItemId, arrival) {
  var arrivalRequest = {
    "numPeopleArrived": arrival.numberOfGuests,
    "note": arrival.note
  }

  var response = await apiClient.patch(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/guest-list-items/' + guestListItemId + '/update-arrived/' + arrival.arrivalId, arrivalRequest);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to patch guest list item.')
}
